import CitySelectorView from '../CitySelectorView.vue'
import CitySelectorPage from '../Pages/CitySelectorPage.vue'

const routes = [
  {
    path: '/seleccionar-ciudad',
    component: CitySelectorView,
    children: [
      {
        path: '',
        name: 'city-selector',
        component: CitySelectorPage,
        // standalone: se renderiza sin el layout PageBase (aún no hay nivel elegido)
        meta: { standalone: true },
      },
    ],
  },
]

export default routes
